<template>
  <div
    class="side-bar-container"
    :class="[
      $store.state.openMenu ? 'down' : 'up',
      $route.name === 'loginPage' ? 'side-nav-login' : 'side',
    ]"
  >
    <slot> </slot>
  </div>
</template>


<script>
export default {
  // props: ["selectedOptionText"],
};
</script>

<style scoped lang="scss">
// .option-selected-conteiner {
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   padding: 10px 10px;
//   background-color: $primaryColorlight;
//   span {
//     font-size: $mediumTextSize;
//   }
// }
@media only screen and (max-width: 601px) {
  //mobile
  .side-nav-login {
    position: unset !important;
    transform: unset !important;
  }
}
.side{
  padding: 50px 0px 20px 0px;
}
.side-bar-container {
  /* height: 350px;
  width: 290px; */

  box-shadow: 0px 4px 4px 0px #00000040;
  z-index: 2;
  border-radius: 0 0 20px 20px;
}

@media (max-width: 992px) {
  .side-bar-container {
    box-shadow: unset;
    padding: 25px;
    margin-bottom: 30px;
  }
}
// @media only screen and (max-width: 350px) {
//   .side-bar-container{
//     padding: 5px;
//   }
// }
</style>